import "../styles/footer.scss";
import { data, logos, items } from "../services/data.ts";

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer id="footer">
      <a href="/">
        <img id="footer-logo" src={logos.full_b_por} height={170} width={240} />
      </a>

      <div className="utiles">
        <div className="adress">
          <h3>Endereço</h3>
          <p>Madison Center</p>
          <a href={data.map_link} className="map adress-text" target="_blank">{data.adress}</a>
          <p>{data.loc}</p>
          <p>{data.city}</p>
          <p>{data.square}</p>
          <p>CEP: {data.cep}</p>
        </div>
        <div className="hour">
          <h3>Horário de atendimento</h3>
          <p>Sob agendamento</p>
        </div>
        <div className="contact" id="contact">
          <h3>Contato</h3>
          <p>{data.phone2}</p>
          <p>{data.email}</p>
          <div className="social">
            <a href={data.instagram_link} target="_blank" >
              <img src={logos.instagram} />
            </a>
            <a href={data.facebook_link} target="_blank">
              <img src={logos.facebook} />
            </a>
            <a href={data.youtube_link} target="_blank">
              <img src={logos.youtube} />
            </a>
            <a href={items.whatsapp} target="_blank">
              <img src={logos.whatsapp} />
            </a>
          </div>
        </div>
        <div className="partner">
          <h3>Parceiros</h3>
          <a href="https://www.instagram.com/aliancadosrelojoeiros/" target="_blank">
            <img src={logos.alianca} />
            <p>Aliança dos Relojoeiros</p>
          </a>
        </div>
      </div>
      <div className="rights">
        <span>Direitos reservados &reg;</span>
        <span>
          Desenvolvido por: <figure id="dev" />
        </span>
      </div>
    </footer>
  );
};

export default Footer;